import { styled } from "@mui/material/styles";
export const StyledCardFieldWrapper = styled("div")<{
  hasError?: boolean;
  isValid?: boolean;
  disabled?: boolean;
}>(({ theme, disabled }) => ({
  display: "flex",
  width: "100%",
  minHeight: 44,
  padding: "12px 16px",
  alignItems: "center",
  boxSizing: "border-box",
  border: "none",
  borderRadius: 8,
  transition: "border-color 0.2s",
  backgroundColor: disabled
    ? theme.palette.action.disabledBackground
    : theme.palette.background.default,

  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },

  "& .StripeElement": {
    width: "100%",
  },

  "& iframe": {
    width: "100%",
    height: "100%",
    pointerEvents: "auto",
  },
}));
